import React from "react";
import { useTranslation } from "react-i18next";
import "./DocumentTitle.scss";
import RemoveDocument from "./RemoveDocument";

function DocumentTitle({
  index,
  required,
  link,
  label,
  documents,
  dispatchUpdateAction,
  bulmaTitleSize = 5,
  color,
  isAdditional = true,
  disabled,
}) {
  const { t } = useTranslation();

  return (
    <div className={`${required ? "pl-3" : ""} is-flex is-size-${bulmaTitleSize}`}>
      {!required && isAdditional && !disabled && (
        <RemoveDocument
          index={index}
          documents={documents}
          dispatchUpdateAction={dispatchUpdateAction}
        />
      )}
      {!isAdditional && color === "grey" && !disabled && (
        <RemoveDocument
          index={index}
          documents={documents}
          dispatchUpdateAction={dispatchUpdateAction}
        />
      )}
      {}
      <span className={required ? "has-text-danger is-required-document" : "is-invisible"}></span>
      <div className="pl-1 pr-1">{`${index + 1}.`}</div>
      {required ? (
        <a className="is-link has-text-dark" target="_blank" rel="noopener noreferrer" href={link}>
          {label}
        </a>
      ) : (
        <input
          placeholder={t("requests.reviewDocuments.additionalDocs.enterDocumentsTitle")}
          className={`has-text-dark is-link document-title-input is-size-${bulmaTitleSize}`}
          value={label ? label : ""}
          onChange={(e) => {
            documents[index].label = e.currentTarget.value;
            dispatchUpdateAction();
          }}
          disabled={disabled ? true : false}
        />
      )}
    </div>
  );
}

export default DocumentTitle;
